module.exports = __webpack_public_path__ + "static/img/suggestion.29b0f32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/suggestion.svg
// module id = hm6G
// module chunks = 11